import { createUseStyles } from 'react-jss'

import { lightGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  fileTypeIcon: {
    position: 'relative',
    color: lightGrey,
    fontSize: [28, '!important']
  },
  fileFormat: {
    width: '100%',
    position: 'absolute',
    fontSize: 7,
    bottom: 6,
    fontStyle: 'normal',
    display: 'block',
    textAlign: 'center',
    fontWeight: '700'
  }
})

export default useStyles
